const CONFIG = {
  KEY: '12345',
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/small/',
  DATABASE_NAME: 'sigmarestoDB',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurant',
  CACHE_NAME: new Date().toISOString(),
};

export default CONFIG;
